import { IStateHistory, IStateHistoryItem } from 'store/reducers/common.slice';

class ActionsHistoryService {
  saveStateInHistory(
    state: IStateHistoryItem,
    history: IStateHistory,
  ): IStateHistory {
    const newHistory = history;

    if (!newHistory.before.length) {
      newHistory.after = [];
    }

    newHistory.before.push(state);

    while (newHistory.before.length > 100) {
      newHistory.before.shift();
    }

    return newHistory;
  }

  undoAction(history: IStateHistory): IStateHistory {
    const newHistory = history;

    if (newHistory.before.length) {
      const lastState = newHistory.before.pop();

      newHistory.after.push(lastState as IStateHistoryItem);

      return newHistory;
    }

    return history;
  }

  redoAction(history: IStateHistory): IStateHistory {
    if (!history.after.length) return history;

    const newHistory = history;

    const nextState = newHistory.after.pop();

    newHistory.before.push(nextState as IStateHistoryItem);

    return newHistory;
  }
}

export default new ActionsHistoryService();
